<template>
    <section id="pricing" :class="'section price-plan-area overflow-hidden ptb_100 ' + (data.gray ? 'bg-gray' : '')">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-7">
                        <!-- Section Heading -->
                        <div class="section-heading text-center">
                            <h2>{{data.title}}</h2>
                            <p class="mt-4">{{data.text}}</p>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-10 col-lg-8">
                        <div class="row price-plan-wrapper">
                            <div v-for="plan in data.plans" :key="plan.id" class="col-12 col-md-6 mt-4 mt-md-6">
                                <!-- Single Price Plan -->
                                <div class="single-price-plan text-center p-5 wow fadeInLeft" data-aos-duration="2s" data-wow-delay="0.4s">
                                    <div v-if="plan.image" class="plan-thumb">
                                        <img class="avatar-lg" :src="plan.image" alt="">
                                    </div>
                                    <div v-if="plan.name" class="plan-title my-2 my-sm-3">
                                        <h3 class="text-uppercase">{{plan.name}}</h3>
                                    </div>
                                    <div v-if="plan.price" class="plan-price pb-2 pb-sm-3">
                                        <h1 class="color-primary"><small class="fw-7">$</small>{{plan.price}}</h1>
                                    </div>
                                    <!-- Plan Description -->
                                    <div v-if="plan.features" class="plan-description">
                                        <ul class="plan-features">
                                            <li v-for="(text, index) in plan.features" :key="index" class="border-top py-3">{{text}}</li>
                                        </ul>
                                    </div>
                                    <!-- Plan Button -->
                                    <div class="plan-button">
                                        <a :href="'/signup?plan='+plan.id" class="btn mt-4">Sign Up</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center pt-5">
                    <p class="text-body pt-4 fw-5">Not sure what to choose? <a href="/contact?subject=Looking for help with turnkey-web pricing">Contact Us</a></p>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    props: ['data']
}
</script>

<style>

</style>